export default __webpack_public_path__ + "static/media/Avanti@3x.3593d608.png";